__turbopack_context__.v({
  "banner": "comboResultFrame-module-scss-module__KCuota__banner",
  "comboResultFrame": "comboResultFrame-module-scss-module__KCuota__comboResultFrame",
  "content": "comboResultFrame-module-scss-module__KCuota__content",
  "draftStatus": "comboResultFrame-module-scss-module__KCuota__draftStatus",
  "exampleStatus": "comboResultFrame-module-scss-module__KCuota__exampleStatus",
  "footer": "comboResultFrame-module-scss-module__KCuota__footer",
  "header": "comboResultFrame-module-scss-module__KCuota__header",
  "okStatus": "comboResultFrame-module-scss-module__KCuota__okStatus",
});
